module.exports = __webpack_public_path__ + "img/figure2.e359f6a6.png";